import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import "vue-code-highlight/themes/prism-okaidia.css";
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },

  {
    path: '/MainLook',
    name: 'mainLook',
    component: () => import(/* webpackChunkName: "about" */ '../views/MainLook.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
